module.exports = __webpack_public_path__ + "img/document-icon.3d73d27e.svg";